import { Einheit } from 'app/models/core/einheit.model';
import { BnrGpPosModel } from '../bnr.gp.pos.model';
import { PosUnDef } from '../gp';

const vblPosDef: BnrGpPosModel[] = [];

// Vertriebsschwerpunkte (außerhalb der Maximierung)
vblPosDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2255001,
		group: 'gwp',
		posText: 'Weiterbildung IDD',
		posDesc: 'Voraussetzung für die Bonifikation ist der Nachweis von 15 Weiterbildungsstunden im Geschäftsjahr',
		planKey: 'idd',
		einheit: Einheit.bew,
	}),
);

vblPosDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'vss',
		posText: 'Strategische Weiterentwicklung Personalthemen',
		posDesc: 'GSL beurteilt die individuelle Zielerreichung anhand konkreter Kriterien',
		planKey: 'personalthemen',
		einheit: Einheit.quali,
	}),
);
vblPosDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'vss',
		posText: 'Qualität in Beratung und VertriebWachstumstriathlon digital.persönlich',
		posDesc: 'GSL beurteilt die individuelle Zielerreichung anhand konkreter Kriterien',
		planKey: '',
		einheit: Einheit.quali,
	}),
);
vblPosDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2255020,
		group: 'vss',
		posText: 'Kundenzuwachs Privat',
		posDesc: 'Anzahl GV/HV mit Erfüllung der Position VSP Kundenzuwachs Privat im Geschäftsplan',
		planKey: 'kundenzuwachs',
		einheit: Einheit.bew,
	}),
);
vblPosDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2255021,
		group: 'vss',
		posText: '',
		posDesc: 'Kundenzuwachs im eigenen VB Bereich ',
		planKey: 'kundenzuwachs',
		einheit: Einheit.bew,
	}),
);
vblPosDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2255030,
		group: 'vss',
		posText: 'Cross-Selling bei Privatkunden Sach/Leben/Kranken',
		posDesc: 'Anzahl GV/HV mit Erfüllung der Position Cross-Selling im Geschäftsplan',
		planKey: '',
		einheit: Einheit.bew,
	}),
);

// Eingangshürde
vblPosDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2255041,
		group: 'eh',
		posText: 'Breitenmaß Gesamtbewertung',
		posDesc: 'Summe prozentuale Zielerfüllung (mindestens 80% - maximal 180%)',
		planKey: '',
		einheit: Einheit.bew,
	}),
);
vblPosDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2255045,
		group: 'eh',
		posText: 'Unfall',
		posDesc: 'Anzahl GV/HV mit mindestens 24 langfristigen Neustück (inkl. MAZ und Co-Verkäufer Zuschlag 12 Stück)',
		planKey: 'khpwkunfalllfnstmaz',
		einheit: Einheit.stck,
	}),
);
vblPosDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2255046,
		group: 'eh',
		posText: 'Leben',
		posDesc: 'Anzahl GV/HV mit Erfüllung der Position VSP Leben Neustück im Geschäftsplan',
		planKey: '',
		einheit: Einheit.stck,
	}),
);

// Nach Eingangshürde (innerhalb einer Maximierung von 10.000 EUR)
vblPosDef.push(new BnrGpPosModel({ year: 2026, posId: 2255121, group: 'neh', posText: 'Sach Privat ohne Kraft/Unfall', posDesc: 'Bewertung', planKey: 'psachokrunfbew', einheit: Einheit.bew }));
vblPosDef.push(new BnrGpPosModel({ year: 2026, posId: 2255131, group: 'neh', posText: 'Unfall', posDesc: 'Bewertung ohne Anpassung ', planKey: 'unfallbew', einheit: Einheit.bew, boniStufen: 2 }));
vblPosDef.push(
	new BnrGpPosModel({ year: 2026, posId: 2255135, group: 'neh', posText: 'Unternehmensschutz', posDesc: 'Langfristige Neustück ', planKey: 'unternehmensschutzlfnst', einheit: Einheit.bew }),
);
vblPosDef.push(new BnrGpPosModel({ year: 2026, posId: 2255141, group: 'neh', posText: 'Sach Firmen', posDesc: 'Bewertung', planKey: 'fsachokraftoanpbew', einheit: Einheit.bew, boniStufen: 2 }));
vblPosDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2255122,
		group: 'neh',
		posText: 'Sach Privat inkl. Unfall Bestandszuwachs Stück',
		posDesc: 'Anzahl GV/HV mit Bestandszuwachs Stück ≥ 1 ',
		planKey: '',
		einheit: Einheit.bew,
	}),
);
vblPosDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2255151,
		group: 'neh',
		posText: 'Leben',
		posDesc: 'Bewertung ohne ZE mit 1,5-facher Wertung PrivateFinance-/PrivateMarketsPolice',
		planKey: 'vaglebenbewdigi',
		einheit: Einheit.bew,
		boniStufen: 2,
	}),
);
vblPosDef.push(new BnrGpPosModel({ year: 2026, posId: 2255161, group: 'neh', posText: 'Fonds', posDesc: 'Bewertung', planKey: 'fondsbew', einheit: Einheit.bew }));
vblPosDef.push(
	new BnrGpPosModel({ year: 2026, posId: 2255171, group: 'neh', posText: 'Kranken', posDesc: 'Bewertung ohne Dynamik ', planKey: 'krankenzusatzbew', einheit: Einheit.bew, boniStufen: 2 }),
);

// GeschäftsplanPlus (ohne Eingangshürde und innerhalb einer Maximierung von 4.000 EUR)
vblPosDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 3855011,
		group: 'gpplus',
		posText: 'Kranken Pflege',
		posDesc: 'Anzahl GV/HV mit Erfüllung der Position VSP Kranken Pflege im Geschäftsplan',
		planKey: 'krankenpflege',
		einheit: Einheit.bew,
	}),
);
vblPosDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 3855031,
		group: 'gpplus',
		posText: 'Leben Einmalbeitrag',
		posDesc: 'Anzahl GV/HV mit mindestens 2.500 Bewertung ohne ZE',
		planKey: 'lebenknpebdigi',
		einheit: Einheit.bew,
	}),
);
vblPosDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 3855041,
		group: 'gpplus',
		posText: 'Kraft Haft PKW und Unfall',
		posDesc: 'Anzahl GV/HV mit Erfüllung der Position VSP Kraft Haft PKW und Unfall im Geschäftsplan',
		planKey: 'khpwkunfalllfnstmaz',
		einheit: Einheit.bew,
	}),
);
vblPosDef.push(
	new BnrGpPosModel({ year: 2026, posId: 3855400, group: 'gpplus', posText: 'Teamausschreibung', posDesc: 'Platzierung in den Positionen im GSW der Vertriebsdirektion', einheit: Einheit.nogoal }),
);
vblPosDef.push(new BnrGpPosModel({ year: 2026, posId: PosUnDef, group: 'gpplus', posText: '', posDesc: 'Kundenzuwachs', einheit: Einheit.nogoal }));
vblPosDef.push(new BnrGpPosModel({ year: 2026, posId: PosUnDef, group: 'gpplus', posText: '', posDesc: 'Cross-Selling ', einheit: Einheit.nogoal }));
vblPosDef.push(new BnrGpPosModel({ year: 2026, posId: PosUnDef, group: 'gpplus', posText: '', posDesc: 'Meine Allianz ', einheit: Einheit.nogoal }));

export const VblPositionen = vblPosDef;
